import { LogLevel } from "./log-level";

export class LogEntry {
    entryDate: Date = new Date();
    message: string = '';
    level: LogLevel = LogLevel.Debug;

    buildLogString(): string {
        return `[${new Date().toLocaleDateString("hu-HU")} ${new Date().toLocaleTimeString("hu-HU")}][${LogLevel[this.level]}] ${this.message}`;
    }
}